import React from 'react';
import PropTypes from 'prop-types';
import { Hyperlink } from '@edx/paragon';

import { NavDropdownArrow } from '../Icons';
import { Menu, MenuContent, MenuTrigger } from '../Menu';

const DynamicNavigationItem = ({ item }) => {
  const {
    name, link, is_blank: isBlank, children,
  } = item;

  if (!item.children || !item.children?.length) {
    return (
      <div className="mobile-nav-item nav-item nav-tab">
        <Hyperlink
          destination={link}
          showLaunchIcon={false}
          target={isBlank ? '_blank' : '_self'}
          className="menu-trigger tab-nav-dropdown"
          rel="noreferrer"
        >
          {name}
        </Hyperlink>
      </div>
    );
  }

  return (
    <Menu
      className="mobile-nav-item nav-item nav-tab"
      transitionClassName="menu-dropdown"
      transitionTimeout={250}
    >
      <MenuTrigger
        tag="button"
        aria-label={children}
        className="tab-nav-dropdown"
      >
        {name}
        <NavDropdownArrow />
      </MenuTrigger>
      <MenuContent className="tab-nav-dropdown-menu">
        {children.map((child) => (
          <a
            role="menuitem"
            href={child.link}
            key={child.link}
            target={child.is_blank ? '_blank' : '_self'}
            className="tab-nav-dropdown-item"
            rel="noreferrer"
          >
            {child.name}
          </a>
        ))}
      </MenuContent>
    </Menu>
  );
};

DynamicNavigationItem.defaultProps = {
  item: null,
};

DynamicNavigationItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    link: PropTypes.string,
    is_blank: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      link: PropTypes.string,
      is_blank: PropTypes.bool,
    })),
  }),
};

export default DynamicNavigationItem;
